<template>
    <div v-if="isLoading && loadingVisibility" data-qa="overlay_loader"
         class="fixed w-full h-full z-50 inset-0 bg-black opacity-75 flex justify-center items-center">
        <img alt="Loading…" class="animate-spin w-24 h-24 select-none" src="/temp/breezeline_pinwheel_white.png" />
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'LoadingOverlay',
        computed: {
            ...mapState([
                'isLoading',
                'loadingVisibility'
            ]),
        },
    }
</script>

<style lang="scss" scoped>
    img {
        animation-duration: 1.5s;
    }
</style>
